<template>
  <div class='xy-content-module'>
    <div class='xy-content-body-ipad'>
      <van-nav-bar style="flex:1" fixed>
        <div slot="left" @click="close">
          <van-icon name="arrow-left" color="#333" size="20" />
        </div>
        <div slot="title">
          <div class="titlediv">选择学生</div>
        </div>
      </van-nav-bar>
      <div class="assessView null-data" v-if="gradeList.length === 0 && isLoad">
        <img src="@/assets/common/moblie-no-data.png" />
        <div>该搜索条件下暂无结果。</div>
      </div>
      <div class="grade-ul-div">
        <ul class="grade-ul">
          <li class="grade-li" :class="item.checked ? 'onSel' : ''" :style="{border:item.checked?'1px solid #1677FF':'1px solid #D5D5D5'}" v-for="(item,index) in gradeList" :key='index' @click="activeHand(item)">
            <div class="li-img">
              <span v-if="item.Icon===''" class="icons" :class="item.Sex === 1 ? 'man' : 'woman'">{{xy.showName(item.StudentName)}}</span>
              <img v-else :src="item.Icon" alt="">
            </div>
            <div class="li-text" style="width: 80%;overflow: hidden;text-align: center;">{{item.StudentName}}
            </div>
            <span class="li-fenshu">{{item.Score}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="sigle-bottom-btn">
      <div class="info-btn" @click="ok" v-if="gradeList.length !== 0">确认</div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
  export default {
    name: '',
    data () {
      return {
        gradeList:[],
        SchoolDistrictID: 0,
        GradeYearID: 0,
        showName: [],
        selectAll: [],

        show:false,
        isShowschool:false,
        isShowgrade:false,
        isShowclass:false,
        showdialog:false,

        schoolId: 0,
        gradeId: 0,
        classId: 0,
        scoreDatas: [],
        
        isLoad: false
      }
    },
    created () {
      Toast.setDefaultOptions('loading', { duration: 0 })
      this.schoolId = this.$route.query.schoolId // 校区 id
      this.gradeId = this.$route.query.gradeId // 年级 id
      this.classId = this.$route.query.classId
      this.scoreDatas = this.$route.query.scoreDatas // 指标数据
      this.getClassList()
    },
    mounted () {},
    methods :{
      unloading() {
        Toast.clear()
      },
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      fail(a, b) {
        if (b) {
          Toast.success({
            message: a,
            className: 'ipad_toast',
            forbidClick: true
          })
        } else {
          Toast.fail({
            message: a,
            className: 'ipad_toast',
            forbidClick: true
          })
        }
      },
      // 获取学生列表
      async getClassList() {
        this.loading()
        let res = await this.xyapi.get(
          `${this.xyMApi}/eva/api/MoralScoreRecordByPad/GetMoralStudentListByPad`,
          {
            SchoolDistrictID: this.schoolId,
            StudentGradeForStudentYearID: this.gradeId,
            StudentOrganizationId: this.classId
          }
        )
        this.unloading()
        if (res.success) {
          this.gradeList = res.data
          this.isLoad = true
          this.gradeList.forEach ((item) => {
            this.$set(item, 'checked', false)
          })
        }
      },
      // 保存打分
      async saveScore() {
        this.loading()
        let pickList = []
        let arr = this.selectAll.concat([])
        for (var x = 0; x < arr.length; x++) {
          for (var y = 0; y < this.scoreDatas.length; y++) {
            let aa = {}
            aa.IndexManagementID = this.scoreDatas[y].value
            aa.Score = this.scoreDatas[y].scoredefault
            aa.AcademicSessionID = arr[x].AcademicSessionID
            aa.AcademicSessionName = arr[x].AcademicSessionName
            aa.AcademicYearID = arr[x].AcademicYearID
            aa.AcademicYearName = arr[x].AcademicYearName
            aa.AccountID = arr[x].AccountID
            aa.Conversion = arr[x].Conversion
            aa.ConversionScore = arr[x].ConversionScore
            aa.IndicatorTypeID = arr[x].IndicatorTypeID
            aa.IsDelete = arr[x].IsDelete
            aa.LastDeleteByDate = arr[x].LastDeleteByDate
            aa.LastDeleteByID = arr[x].LastDeleteByID
            aa.ProgrammeID = arr[x].ProgrammeID
            aa.RecordDate = arr[x].RecordDate
            aa.RecordID = arr[x].RecordID
            aa.SchoolDistrictID = arr[x].SchoolDistrictID
            aa.SchoolDistrictName = arr[x].SchoolDistrictName
            aa.ScoreByID = arr[x].ScoreByID
            aa.ScoreDate = arr[x].ScoreDate
            aa.ScoreType = arr[x].ScoreType
            aa.StarScore = arr[x].StarScore
            aa.StudentGradeForStudentYearID = arr[x].StudentGradeForStudentYearID
            aa.StudentGradeID = arr[x].StudentGradeID
            aa.StudentGradeNameForStudentYearName = arr[x].StudentGradeNameForStudentYearName
            aa.StudentID = arr[x].StudentID
            aa.StudentName = arr[x].StudentName
            aa.StudentOrganizationId = arr[x].StudentOrganizationId
            aa.StudentOrganizationName = arr[x].StudentOrganizationName
            aa.StudentYearID = arr[x].StudentYearID
            aa.UserName = arr[x].UserName
            aa.WeekDay = arr[x].WeekDay
            pickList.push(aa)
          }
        }
        let res = await this.xyapi.post(`${this.xyMApi}/eva/api/MoralScoreRecordByPad/SaveScoreRecodStudentByPad`, {
          MoralEducationScoreRecordStudentList: pickList
        })
        this.unloading()
        if (res.success) {
          this.fail(res.msg || '保存成功。', true)
          setTimeout(() => {
            this.close()
          }, 1000)
        }
      },
      close() {
        this.$router.go(-1)
      },
      activeHand(item){
        let indexs = -1
        item.checked = item.checked ? false : true
        if(item.checked){
          this.selectAll.push(item)
        }else{
          for(let i=0,len=this.selectAll.length;i<len;i++){
            if(this.selectAll[i].StudentID ===item.StudentID){
              indexs=i
            }
          }
        }
        if(indexs!==-1)
          this.selectAll.splice(indexs,1)
      },
      ok(){
        if (this.selectAll.length !== 0) {
          this.saveScore()
        } else {
          this.fail("请先选择要评价的学生。")
        }
      }
    }
  }
</script>
<style lang='less'>
.titlediv {
  font-size: 16px;
}
.assessView {
  width: 100%;
  height: 670px;
}
.null-data {
  margin-top: 100px;
  text-align: center;
  div {
    // prettier-ignore
    font-size:18Px;
  }
}
.man {
  background: #4196ff;
}
.woman {
  background: #FF81AC;
}
.van-nav-bar {
  height: 60px;
  line-height: 60px;
  color: #1a1a1a;
  font-weight: 500;
}
.van-dialog__message {
  font-size: 16px !important;
  padding: 3.2vw;
}
.van-button__text {
  font-size: 16px !important;
}
.van-button--large {
  height: 6.6vw;
  line-height: 3.2vw;
}
.xy-content-body-ipad{
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .changeAll{
    background: #fff;
    height: 80px;
    width: 100%;
    border-bottom: 20px solid #f5f5f5;
    font-size: 18Px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    div{
      padding:10px;
      flex: 1;
      text-align: center;
      img{
        width:20px;
        height:20px;
        margin-left:10px;
      }
    }
  }
  .select-more{
    font-size: 22Px;
    text-align: center;
  }
  .grade-ul-div{
    width: 1004px;
    margin: 25px 10px 10px;
    padding-bottom: 120px;
    .grade-ul{
      padding: 20px 10px 10px 20px;
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      .onSel{
        background: url(./img/group.png) no-repeat 95px 104px;
        background-size: 63px 63px;
      }
      .grade-li{
        width: 129px;
        height: 135px;
        border-radius: 4px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        margin-right: 10px;
        margin-bottom: 10px;
        justify-content: center;
        align-items: center;
        position: relative;
        .li-img{
          margin-bottom: 8px;
          margin-top:10px;
          .icons{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 54px;
            height: 54px;
            text-align: left;
            border-radius: 50%;
            font-size: 16Px;
            color: #fff;
          }
          img {
            width: 54px;
            height: 54px;
            border-radius: 50%;
          }
        }
        .li-text{
          font-size: 18Px;
          position: relative;
        }
        .li-fenshu{
          position: absolute;
          font-size: 20Px;
          color: #E27730;
          top:8px;
          right: 10px;
          font-weight: bold;
        }
      }
    }
  }
}
.sigle-bottom-btn {
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 99999 !important;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px;
  .info-btn {
    width: 74px;
    height: 32px;
    background: #1677ff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 14Px;
  }
}

</style>
